import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, XIcon } from 'lucide-react';
const names = ['Giulia R.', 'Marco T.', 'Francesca M.', 'Luca B.', 'Sara C.', 'Matteo G.', 'Valentina P.', 'Andrea S.', 'Chiara L.', 'Davide F.', 'Martina D.', 'Simone R.', 'Elena V.', 'Lorenzo C.', 'Alessia N.', 'Federico M.', 'Silvia A.', 'Giorgio P.', 'Roberta B.', 'Stefano L.', 'Ilaria G.', 'Paolo D.', 'Federica T.', 'Nicola S.', 'Beatrice F.'];
const cities = ['Roma', 'Milano', 'Napoli', 'Torino', 'Palermo', 'Genova', 'Bologna', 'Firenze', 'Bari', 'Catania', 'Venezia', 'Verona', 'Padova', 'Trieste', 'Brescia', 'Parma', 'Modena', 'Bergamo', 'Cagliari', 'Perugia', 'Pescara', 'Rimini', 'Salerno'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 15) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    function showNotification() {
      setData({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        setVisible(false);
      }, 4000);
    }
    // First popup after 15 seconds
    const initialTimeout = setTimeout(showNotification, 15000);
    // Then every 35-50 seconds
    const interval = setInterval(showNotification, 35000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-385" data-mp="1f0wq38dlpptc">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -40
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-4 z-[60] max-w-[300px] md:bottom-6" role="status" aria-live="polite" data-id="element-386" data-mp="1a1agra0w8tpt">
          <div className="bg-slate-900/95 backdrop-blur-md rounded-2xl shadow-2xl shadow-black/50 border border-white/10 p-3.5 flex items-start gap-3" data-id="element-387" data-mp="1r1n0s0yamjcn">
            <div className="w-9 h-9 bg-emerald-500/15 rounded-full flex items-center justify-center shrink-0" data-id="element-388" data-mp="1vv7sxcd7gj3x">
              <ShoppingBag size={17} className="text-emerald-400" aria-hidden="true" data-id="element-389" data-mp="24tt4uoo68zvq" />
            </div>
            <div className="min-w-0" data-id="element-390" data-mp="29tfj91fqkm64">
              <p className="text-sm font-semibold text-white leading-tight" data-id="element-391" data-mp="29uh4fyqgup1k">
                {data.name} da {data.city}
              </p>
              <p className="text-xs text-slate-300 mt-0.5" data-id="element-392" data-mp="2epwgcl4wyavc">
                ha appena acquistato{' '}
                <span className="font-semibold text-sky-400" data-id="element-393" data-mp="fhhhfkjrask9">
                  Megapack Funzionale 365
                </span>
              </p>
              <p className="text-[11px] text-slate-500 mt-1" data-id="element-394" data-mp="cvrz5rt1r14k">
                {data.minutes} minuti fa
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-slate-500 hover:text-white transition-colors duration-150 ml-auto shrink-0 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400" aria-label="Chiudi notifica" data-id="element-395" data-mp="81x6hyvgrbtc">
              <XIcon size={14} aria-hidden="true" data-id="element-396" data-mp="vtul1xqashy5" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}